import { z } from '@/libs/zod';

export const prizeSchema = z.object({
  name: z.string(),
  type: z.string(),
  isDrawn: z.boolean(),
  prizeUrls: z.string(),
  prizeValue: z.number(),
});

export const ticketByRaffleSchema = z.object({
  sequence: z.string(),
  winning: z.boolean(),
  prizes: z.array(prizeSchema),
  date: z.string(),
  id: z.string(),
  hasBeenScratched: z.boolean(),
});

export const userSchema = z.object({
  cpf: z.string(),
  phone: z.string(),
  name: z.string(),
});

export const adRaffleSchema = z.object({
  id: z.string().uuid(),
  raffleId: z.string().uuid(),
  active: z.boolean(),
  duration: z.number(),
  minPercentage: z.number(),
  sequence: z.number(),
  link: z.string().url(),
  discount_percentage: z.number(),
  promotionPacks: z.array(z.string()),
});

export const ticketsByRaffleResponseSchema = z.object({
  data: z.array(ticketByRaffleSchema),
  prizeNames: z.array(z.string()),
  prizeUrls: z.array(z.string()),
  prizeValues: z.array(z.number()),
  ticketsToScratch: z.number(),
  totalCount: z.number(),
  urlScratcherBanner: z.string().optional(),
  user: userSchema,
  raffleId: z.string(),
  capitalizer: z.string().nullable(),
  tickets: z
    .array(
      z.object({
        hasBeenScratched: z.boolean(),
        sequence: z.string(),
        prizes: z.array(z.any()),
        id: z.string(),
        winning: z.boolean(),
      }),
    )
    .optional(),
  adRaffle: adRaffleSchema.optional(),
});

export type Prize = z.infer<typeof prizeSchema>;
export type TicketByRaffle = z.infer<typeof ticketByRaffleSchema>;
export type User = z.infer<typeof userSchema>;
export type AdRaffle = z.infer<typeof adRaffleSchema>;
export type TicketsByRaffleResponse = z.infer<typeof ticketsByRaffleResponseSchema>;

export type TicketsByRaffleParams = {
  cartRaffleId: string;
  take?: number;
  skip?: number;
  cpf: string;
  phone: string;
  hasBeenScratched?: boolean;
};

export type TicketsByRafflePostBody = {
  customerId: string;
  fbc?: string;
  fbp?: string;
  isFromBalance?: boolean;
  purchaseWithPromotion?: boolean;
  raffleId: string;
  ticketsAmount?: number;
};
